namespace RedBullMOBILE360.Membership {

    @Serenity.Decorators.registerClass()
    export class SignUpPanel extends Serenity.PropertyPanel<SignUpRequest, any> {

        protected getFormKey() { return SignUpForm.formKey; }

        private form: SignUpForm;

        constructor(container: JQuery) {
            super(container);
            $.fn['vegas'] && $('body')['vegas']({
                delay: 30000,
                cover: true,
                overlay: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U" +
                    "/gAAAABlBMVEX///8AAABVwtN+AAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0" +
                    "aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljaGBgAAABhACBrONIPgAAAABJRU5ErkJggg==",
                slides: [
                    {
                        src: Q.resolveUrl("~/Content/site/images/slides/1.png"),
                        video: {
                            src: [
                                Q.resolveUrl("~/Content/site/images/slides/1.mp4")
                            ],
                            loop: false,
                            mute: true
                        }
                    },
                    { src: Q.resolveUrl("~/Content/site/images/slides/2.png"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/3.png"), transition: 'swirlLeft' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/4.png"), transition: 'fade' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/5.png"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/6.png"), transition: 'swirlLeft' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/7.png"), transition: 'fade' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/1.png"), transition: 'fade' },
                ]
            });

            this.form = new SignUpForm(this.idPrefix);

            this.form.ConfirmEmail.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmEmail.value !== this.form.Email.value) {
                    return Q.text('Validation.EmailConfirm');
                }
            });

            this.form.ConfirmPassword.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmPassword.value !== this.form.Password.value) {
                    return Q.text('Validation.PasswordConfirm');
                }
            });

            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }

                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/SignUp'),
                    request: {
                        DisplayName: this.form.DisplayName.value,
                        Email: this.form.Email.value,
                        Password: this.form.Password.value
                    },
                    onSuccess: response => {
                        Q.information(Q.text('Forms.Membership.SignUp.Success'), () => {
                            window.location.href = Q.resolveUrl('~/');
                        });
                    }
                });

            });
        }
    }
}